import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { I18NService } from '@ebw-monorepo/i18n-translate';
import { LoginService } from '@ebw-monorepo/login';
import { EbwModalService } from '@ebw-monorepo/modal';
import { UtilsService } from '@ebw-monorepo/utils';
import { debounceTime } from 'rxjs';
import { API_URLS, ApiUrlService } from '../../../../../../utils/src/lib/services/api-url.service';
import { NormalizePipe } from '../../../pipe/normalize.pipe';
import { UuidPipe } from '../../../pipe/uuid.pipe';
import { MapService } from './../../../services/map.service';
import { FormLayersModalComponent } from './form-layers-modal/form-layers-modal.component';

@Component({
  selector: 'ebw-dynamic-layers',
  templateUrl: './dynamic-layers.component.html',
  styleUrls: ['./dynamic-layers.component.scss'],
  providers: [UuidPipe, NormalizePipe]
})
export class DynamicLayersComponent implements OnInit {
  layersList: { id: string; label: string; visible: boolean; owner: string }[] = [];
  public publicPermission: boolean;

  oldLayers: { title: string; visibility: boolean }[] = [];

  constructor(
    private mapService: MapService,
    private loginService: LoginService,
    public dialog: MatDialog,
    private ebwModal: EbwModalService,
    private i18nSrv: I18NService,
    private utilsService: UtilsService,
    private _uuidPipe: UuidPipe,
    private _normalizePipe: NormalizePipe,
    private _apiUrlService: ApiUrlService
  ) {}

  /**
   * init method, called upon component creation
   */
  ngOnInit(): void {
    this.mapService.mapLayersLoaded$.pipe(debounceTime(500)).subscribe({
      next: (res) => {
        this.getLayersList();
      }
    });
  }

  /**
   * method called to get the list of available THIRDPARTY layers
   */
  getLayersList() {
    this.layersList = [];
    this.layersList = this.mapService.getCustomLayers('THIRDPARTY');
  }

  /**
   * method to add a new layer through a menu
   */
  addNewLayers() {
    // open the menu with the form to create a new layer
    let ref = this.dialog.open(FormLayersModalComponent, {
      maxWidth: '100vw',
      maxHeight: '100%',
      // height: '100%',
      width: '40%'
    });

    // listen to the response of the menu when closed ("CORRECT", "ERROR", "RELOAD")
    ref.afterClosed().subscribe((resp) => {
      switch (resp) {
        case 'CORRECT':
          this.getLayersList();
          break;

        case 'RELOAD':
          this.mapService.emitReloadConfRequest();
          break;

        default:
          break;
      }
    });
  }

  /**
   * method called to change the visibility of a specified layer
   * @param {id: string, visible: boolean} layer object with layer information
   */
  setVisibility(layer: { id: string; visible: boolean }) {
    this.mapService.setLayerVisibility(layer.id, layer.visible);
  }

  /**
   * method called to remove the specified layer
   * @param {id: string, visibility: boolean} layer object with layer information
   */
  removeLayers(layer: { id: string; label: string; owner: string }) {
    // get the message for the confirmation popup menu
    let message: string = this.i18nSrv.getTranslateParameter(
      'map.sidebar.dynamic_layers.delete_modal_message',
      layer.label
    );

    // open a confirm modal menu
    this.ebwModal
      .openConfirmModal({
        content: message,
        title: this.i18nSrv.getInstantValue('map.sidebar.dynamic_layers.delete_layer')
      })
      .afterClosed()
      .subscribe((result) => {
        // check if the user confirmed or not
        if (result != true) {
          return;
        }

        const baseUrl = this._apiUrlService.createUrl(API_URLS.MAP.LAYER.DELETE_LAYER);
        const url = `${baseUrl}?id=${layer.id}`;
        this.utilsService.deleteRequest(url, undefined, false).subscribe({
          next: () => {
            this.mapService.removeLayer(layer.id);
            this.getLayersList();
          },
          error: (error) => {
            console.error('[DynamicLayers] [removeLayer]', error);
            const title = this.i18nSrv.getInstantValue('common.error_message_intro');
            const content = this.i18nSrv.getInstantValue('common.delete_error');
            this.ebwModal.openErrorModal({
              title,
              content
            });
          }
        });
      });
  }

  getTooltip(layerTitle: string): string {
    let formattedTitle = this._normalizePipe.transform(this._uuidPipe.transform(layerTitle));
    return formattedTitle.length > 25 ? formattedTitle : '';
  }

  checkIfCanDelete(layer: { owner: string }): boolean {
    const userId = this.loginService.getUserId();
    return layer.owner == userId;
  }
}
